import { api, unwrapApiResult } from './api'
import { parseVersionModel, VersionInterface } from '../models/VersionModel'

export async function getVersion() {
  const result = await api(<VersionInterface>{
    method: 'GET',
    url: '/appversion',
  })

  const data = unwrapApiResult(result)

  return parseVersionModel(data)
}
